import Mobile from 'mlmi-library/modules/mobile/v1/mobile';
import ViewportSizer from 'mlmi-library/components/viewport/v1/viewport';
import LayersSystem from './modules/Layers.js';
import Player from '@vimeo/player';
import YouTubePlayer from 'youtube-player';
import Scrollbar from 'mlmi-library/components/scrollbar/v1/scrollbar';
import './modules/PhotoPlace.js';
import './modules/Transition.js';
import './modules/Filters.js';
import './modules/AxisMove.js';
import './modules/Cursor.js';
import 'mlmi-library/plugins/bem';
import 'jquery.marquee';
import Swiper from 'swiper';

$(document).ready(function()
{
  /* Launch the layers system */
  if (!$('head').hasClass('page-template-page')) {
    new LayersSystem();
  }

  /* Viewport sizer */
  new ViewportSizer({
    selector: '.layer__sizer',
    inner: '.wrapper',
  });

  /* Single page scrollbar*/
  let single_page_scrollbar = new Scrollbar('.single-page-template__content-wrapper');

  /* Fix long title on single pages */
  $(window).on('load orientationchange resize', function() {
    $('.single-page-template').css('--title-height', $('.single-page-template__title').outerHeight() + 'px')
  })

  /* Sidebar clone */
  const sidebar = $('.sidebar').clone();

  /* Mobile toggle */
  const mobileToggle = function()
  {
    if (mobileChecker.isMobile) {
      /* Move sidebar */
      $('.desktop-sidebar').empty();
      $('.mobile-sidebar').empty().prepend(sidebar.clone());
    } else {
      /* Move sidebar */
      $('.mobile-sidebar').empty();
      $('.desktop-sidebar').empty().prepend(sidebar.clone());
    }
  };

  /* Project scroll handler */
  const projectScroll = function()
  {
    if ($('.layer--current.layer--parent').offset() != undefined) {
      let currentScroller = $('.layer--current .layer__child .scroller'),
      layerHeight = $('.layer--current.layer--parent').outerHeight(false),
      layerOffset = $('.layer--current.layer--parent').offset().top;
      currentScroller.find('.fadein:not(.fadein--visible)').each(function() {
        if ($(this).offset().top - layerOffset < layerHeight * 0.95) {
          $(this).addClass("fadein--visible");
        }
      });
    }
  };

  /* Mobile checker */
  const mobileChecker = new Mobile();
  $(window).on('toggle', mobileToggle);
  mobileToggle();

  /* Photo place */
  const photoPlace = $('<div>').PhotoPlace();

  /* Space between instagram slides */
  const getSpaceBetween = function() {
    let spaceBetween = Math.round(($(window).width() - $('.content-width').outerWidth(true)) / 2) + $('.instagram--position-3:first').width() - 20;
    return spaceBetween;
  };

  /* Manual flags */
  var homeSwiperInitialized = false,
  instagramSwiperInitialized = false;

  /* Update ticker */
  const updateTicker = function()
  {
    // remove previous marquees
    let previousMarquees = $('.marquee'),
    currentSlide = $('.layer--home .swiper-slide-active');
    if (!currentSlide.length) {
      currentSlide = $('.layer--home .swiper-slide');
    }
    setTimeout(function() {
      previousMarquees.remove();
    }, 500);

    // create marquee
    let words = currentSlide.find('.marquee-words').html(),
    newMarquee = $('<div class="marquee">').append(words).append(words).append(words);
    $('.layer--home .layer__toolbar').append(newMarquee);
    newMarquee.marquee({
      speed: 100,
      delayBeforeStart: 0,
      gap: 0,
      duplicated: true,
      startVisible: true,
    }).css('opacity', 1);
  };

  /* Cursors */
  let videoCursor = $('.cursor').clone().Cursor('.play-zone.has-video', 'play'),
  instagramCursor = $('.cursor').clone().Cursor('.instagram-slider', 'slider');
  $('.layer--projects').append(videoCursor);
  $('.layer--infos').append(instagramCursor);

  /* Page load */
  const pageLoad = function()
  {
    /* Instagram photos */
    $('.layer--infos .instagram__photo').each(function() {
      let image = $(this).find('img')
      if (!image.hasClass('original')) {
        image.after(image.clone().addClass("copy"));
        image.addClass('original');
      }
    });

    /* Photo place */
    $('.layer--projects .layer__content').before(photoPlace);

    /* Home swiper */
    if (!homeSwiperInitialized && $('.layer--current .swiper-container.home-slider .swiper-slide').length > 1) {
      homeSwiperInitialized = true;
      let homeSwiper = new Swiper('.layer--current .swiper-container.home-slider', {
        init: false,
        direction: 'horizontal',
        loop: true,
        grabCursor: false,
        simulateTouch: false,
      }),
      homeCursor = $('.cursor').clone().Cursor('.home-slider', 'slider');
      homeSwiper.on('slideChangeTransitionEnd', updateTicker);
      homeSwiper.init();
      $('.layer--current .swiper-container.home-slider').data('swiper', homeSwiper);
      $('.layer--home').append(homeCursor);
    } else if ($('.layer--current .swiper-container.home-slider').length === 1) {
      setTimeout(function() {
        updateTicker();
      }, 500);
    }

    /* Instagram swiper */
    if (!instagramSwiperInitialized && $('.layer--current .swiper-container.instagram-slider .swiper-slide').length > 1) {
      instagramSwiperInitialized = true;
      let instagramSwiper = new Swiper('.layer--current .swiper-container.instagram-slider', {
        init: false,
        spaceBetween: getSpaceBetween(),
        direction: 'horizontal',
        loop: true,
        loopAdditionalSlides: 1,
        grabCursor: false,
        simulateTouch: false,
      });
      $(window).on("resize orientationchange load", function() {
        instagramSwiper.params.spaceBetween = getSpaceBetween();
        instagramSwiper.update();
      });
      instagramSwiper.init();
      $('.layer--current .swiper-container.instagram-slider').data('swiper', instagramSwiper);
    }

    /* Posters slider */
    if ($('.swiper-container.posters-slider .swiper-slide').length > 1) {
      new Swiper('.swiper-container.posters-slider', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        centeredSlides: true,
        grabCursor: true,
      });
    }

    /* Filters */
    $('.filters').Filters();

    /* Clicked on next remains hovered */
    $(document).on("click", ".pagination__link", function() {
      $(this).addClass("hover");
    });

    /* Scroll down button */
    $(document).on("click", ".scroll-down", function() {
      $('.layer--current .scroller').animate({
        scrollTop: $('.layer--current .video-player').height() + "px",
      }, 650, "swing");
    });

    /* Vimeo player */
    let vimeoFrame = $('.layer__child:last .vimeo-player iframe');
    if (vimeoFrame.length) {
      let vimeoPlayer = new Player(vimeoFrame.get(0));
      vimeoFrame.data('vimeo-player', vimeoPlayer);
      $('.play-zone.has-video').off('click').on('click', function() {
        $(this).fadeOut();
        $('.scroll-down').fadeOut();
        vimeoPlayer.play();
      });
    }

    /* YouTube player */
    let youtubeFrame = $('.layer__child:last .youtube-player');
    if (youtubeFrame.length) {
      let youtubeID = youtubeFrame.data('youtube'),
      youtubePlayer = YouTubePlayer('youtube-' + youtubeID);
      youtubePlayer.cueVideoById(youtubeID);
      $('.play-zone.has-video').off('click').on('click', function() {
        youtubePlayer.playVideo();
        $(this).fadeOut();
        $('.scroll-down').fadeOut();
      });
    }

    /* Details scroll */
    $('.layer__child .scroller').on('scroll', projectScroll);

    /* Axis Move */
    $('.layer--home .arrow-slider').each(function() {
      if (!$(this).data('axismove')) {
        $(this).AxisMove($(this).find('.slide__content__image, .projects'));
      }
    });
    $('.layer--infos .arrow-slider').each(function() {
      if (!$(this).data('axismove')) {
        $(this).AxisMove($(this).find('.photos-grid'));
      }
    });

    /* Call responsive actions */
    mobileToggle();
    return this;
  };
  $(window).on('page_load', pageLoad);
  $(window).on('page_load_layers', pageLoad);
  pageLoad();

  /* Closing first layer */
  $('.layer--home').on('closing-start', function() {
    $(this).find('.content').css('height', $(this).find('.content').outerHeight(false) + "px");
  }).on('closing-end', function() {
    $(this).find('.content').css('height', '');
  });

  /* Home hover */
  $(document).on('mouseenter', '.project', function() {
    $('.wrapper').addClass('project-hovered');
  }).on('mouseleave', '.project', function() {
    $('.wrapper').removeClass('project-hovered');
  })

  /* Projects hover */
  $(document).on('mouseenter', '.projects__list a.project__link', function() {
    $('.layer--projects').addClass('reversed');
    photoPlace.place($(this).data('id'), $(this).data('image'));
  }).on('mouseleave', '.projects__list a.project__link', function() {
    $('.layer--projects').removeClass('reversed');
    photoPlace.unplace();
  });

  /* Instagram hover */
  $(document).on('mouseenter', '.instagram', function() {
    $('.wrapper').addClass('instagram-hovered');
  }).on('mouseleave', '.instagram', function() {
    $('.wrapper').removeClass('instagram-hovered');
  })

  /* Window resize as scroll */
  $(window).on('orientationchange resize', projectScroll);
});
